var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('message-password'),_c('message-organisation-switch'),_c('message-merkato-initialize')],1)}
var staticRenderFns = []

export { render, staticRenderFns }